import { Logger as _Logger } from 'loglevel';
import { PluginFunction } from './plugin';

const apply = (rootLogger: _Logger, plugins: PluginFunction[]) => {
  plugins.forEach((plugin) => {
    const currentFactory = rootLogger.methodFactory;
    rootLogger.methodFactory = (methodName, logLevel, loggerName) => {
      const method = currentFactory(methodName, logLevel, loggerName);
      return function (message) {
        try {
          return plugin({ method, message, methodName, logLevel, loggerName });
        } catch (e) {
          console.error('Plugin execution failure', e);
          method(message);
        }
      };
    };
  });
};

export { apply };
